import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Horas from '../store/assets/Horas.png'
import horas1 from '../store/assets/horas1.jpg';
import horas2 from '../store/assets/horas2.jpg';
import horas3 from '../store/assets/horas3.jpg';
import horas4 from '../store/assets/horas4.jpg';
import horas5 from '../store/assets/horas5.jpg';
import horas6 from '../store/assets/horas6.jpg';
import horas7 from '../store/assets/horas7.jpg';
import horas8 from '../store/assets/horas8.jpg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './LandingPage.css'

class LandingPage extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      variableWidth:true,
      adaptiveHeight: true,
      speed: 2000,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      cssEase: "linear"
    };
    return (
      <div className="landing-main-container">
        <section id="landing-header">
          <header>
            <img src={Horas} width="200" alt="logo"/>
          </header>
        </section>
      
        <section id="landing-main">
          <div className="landing-main-text">
            Horas Astrology. <br/> We answer your every question. <br/>
            Your <span class="ii">FUTURE</span> is fantastic.
          </div>

          <div className="landing-slide-show">
          <Slider {...settings}>
            <div>
              <img src={horas1} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas2} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas3} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas4} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas5} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas6} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas7} height='60%' width='60%'></img>
              </div>
              <div>
              <img src={horas8} height='60%' width='60%'></img>
            </div>
          </Slider>
      </div>
      </section>

      <section id="landing-des">
        <div className="landing-description">
      This is an astrology app from one of the most prestigious Vedic Astrologer from Nepal and India. You can get answer to any question about your life, love or career path. Get answers to your queries from the famous group of astrologers who have dedicated years of their live in Vedic science, Personal Astrology, Business Astrology and cosmic sciences.

<div className="landing-googleplay">
      <a href='https://play.google.com/store/apps/details?id=com.horas.horas'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png' width='300'/></a>
      </div>
      </div>
      </section>
      </div>
    );
  }
}
export default withRouter(LandingPage);

export {
    LandingPage,
};


// WEBPACK FOOTER //
// ./src/Components/LandingPage.js